import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Metadata, MetadataType, MetadataTypeIdentifier } from 'src/app/common/models/metadati/metadata';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
//import * as uuid from 'uuid';

//import { getMockMetadataType, mockMetadata, mockMetadataTypes } from './mock';
import { MetadataAssociateRequest } from 'src/app/common/models/metadati/metadataAssociatedRequest';
import { ItemOrder } from 'src/app/lem/models/common/item-order';
import { MetadataAssociationResponse } from 'src/app/common/models/metadati/metadataAssociationResponse';

@Injectable({
  providedIn: 'root'
})
export class MetadatiService {


  metadataPath = ServicePathsSettings.URL_METADATA;
  allActivePath = this.metadataPath + ServicePathsSettings.URL_METADATA_ACTIVE;
  typePath = this.metadataPath + ServicePathsSettings.URL_METADATA_TYPES;
  getByIdentifierPath = this.metadataPath + ServicePathsSettings.URL_METADATA_GET_BY_IDENTIFIER;
  getByPracticeTypePath = this.metadataPath + ServicePathsSettings.URL_METADATA_PRACTICE_TYPE;
  getByDossierTypePath = this.metadataPath + ServicePathsSettings.URL_METADATA_DOSSIER_TYPE;
  disablePath = this.metadataPath + ServicePathsSettings.URL_METADATA_DISABLE;
  enablePath = this.metadataPath + ServicePathsSettings.URL_METADATA_ENABLE;
  metadati = [];

  private _refreshRequired$ = new Subject<void>();

  constructor(
    private http : HttpClient,
  ) {}

  get RefreshRequired$ () {
    return this._refreshRequired$.asObservable();
  }

  add(metadato: Metadata): Observable<PaginatedResponse<Metadata>> {
    this.metadati.push(metadato)
    metadato = this.formatRequest(metadato);
    if(!metadato.id){
      return this.http.post<PaginatedResponse<Metadata>>(this.metadataPath , metadato);
    } else {
      return this.http.put<PaginatedResponse<Metadata>>(this.metadataPath , metadato);
    }
  }

  disable(identifier: string, metadata: Metadata): Observable<Metadata> {
    return this.http.put<Metadata>(this.disablePath + '/' + identifier, metadata);
  }

  enable(identifier: string, metadata: Metadata): Observable<Metadata> {
    return this.http.put<Metadata>(this.enablePath + '/' + identifier, metadata);
  }

  getAll(obj: any, params: Map<string, string>, pagable: Pagable): Observable<PaginatedResponse<Metadata>> {
    let queryParams = new HttpParams({});
    if (obj) {
      queryParams = new HttpParams({ fromObject: obj });
    } else if (params) {
      params.forEach((value: string, key: string) => {
        queryParams = queryParams.append(key, value);
      });
    }
    if (pagable) {
      queryParams = queryParams.append('page', '' + pagable.page);
      queryParams = queryParams.append('size', '' + pagable.size);
    }

    const requestOptions = { params: queryParams };



    return this.http.get<PaginatedResponse<Metadata>>(this.metadataPath, requestOptions);
  }


  getAllActive(obj: any, params: Map<string, string>, pagable: Pagable): Observable<PaginatedResponse<Metadata>> {
    let queryParams = new HttpParams({});
    if (obj) {
      queryParams = new HttpParams({ fromObject: obj });
    } else if (params) {
      params.forEach((value: string, key: string) => {
        queryParams = queryParams.append(key, value);
      });
    }
    if (pagable) {
      queryParams = queryParams.append('page', '' + pagable.page);
      queryParams = queryParams.append('size', '' + pagable.size);
    }

    const requestOptions = { params: queryParams };



    return this.http.get<PaginatedResponse<Metadata>>(this.allActivePath, requestOptions);
  }

  findByIdentifier(identifier: string): Observable<Metadata> {
    return this.http.get<Metadata>(this.getByIdentifierPath+'/'+identifier);
  }

  getAllTypes(): Observable<PaginatedResponse<MetadataType>> {
    /* return new Observable<PaginatedResponse<MetadataType>>(observer => {
      observer.next(this.mockMetadataType());
      observer.complete();
    }); */
    return this.http.get<PaginatedResponse<MetadataType>>(this.typePath);
  }

  findAllByDossierType(idDossier : string): Observable<ItemOrder<Metadata>[]> {
    return this.http.get<ItemOrder<Metadata>[]>(this.getByDossierTypePath+'/'+idDossier);
  }

  findAllByPracticeType(idPractice: string): Observable<ItemOrder<Metadata>[]> {
    return this.http.get<ItemOrder<Metadata>[]>(this.getByPracticeTypePath+'/'+idPractice);
  }

  associateDossierType(request: MetadataAssociateRequest): Observable<ItemOrder<Metadata>[]>{
    return this.http.put<ItemOrder<Metadata>[]>(this.getByDossierTypePath+'/'+request.typeId, request.metadatiSelected);
  }

  associatePracticeType(request: MetadataAssociateRequest): Observable<ItemOrder<Metadata>[]>{
    return this.http.put<ItemOrder<Metadata>[]>(this.getByPracticeTypePath+'/'+ request.typeId, request.metadatiSelected);
  }

  /*mockMetadata():PaginatedResponse<Metadata>{
    this.metadati.forEach(meta => {
      if(!meta.id){
        meta.id = 'TEMP_'+uuid.v4();
      }
    })
    let res = {totalItems:this.metadati.length , items:this.metadati} ;
    return res;
  }*/

  private formatRequest(metadato : Metadata):Metadata{

    if(metadato.options){
      metadato.options.forEach(opt =>{
        if(opt.id.startsWith('TEMP')){
          opt.id = undefined;
        }
      })
      metadato.type ={
        id: metadato.type.id,
        name: undefined,
        description: undefined,
        validators : undefined,
        hasOptions: undefined
      }
    }
    return metadato;
  }


}
